import Dictionary from "./Dictionary";

const instance = new Dictionary();

export default instance;
